<template lang="pug" src="./logging.pug"> </template>
<style lang="scss" src="./logging.scss" scoped> </style>

<script>
import { mapState } from 'vuex';
import { translateActionType } from '@/utils/translation';

export default {
    data: () => ({
        startDate: null,
        startDateModal: null,
        endDate: null,
        endDateModal: null,
        filters: {
            types: [],
            startDate: null,
            endDate: null,
            userId: null
        }
    }),
    computed: {
        ...mapState({
            actionTypes(state) {
                return state.logging.actionTypes.map(it => ({
                    id: it.id,
                    name: this.$vuetify.lang.t(`$vuetify.actionTypes.${it.name}`),
                }));
            },
            pagination: state => state.logging.pagination,
            actionLogs: (state) => state.logging.actionLogs
        }),
        headers() {
            return ['userId', 'actionTypeId', 'createdAt', 'action'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Logging.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created: function() {
        this.$store.dispatch('data/getBrands');
        this.$store.dispatch('logging/getActionTypes');
        this.getLogs();
    },
    methods: {
        changeEndDate() {
            this.endDateModal = false;
        },

        changeStartDate() {
            this.startDateModal = false;
        },

        translateAction(item) {
            return translateActionType.call(this, item);
        },

        getLogs(page = 1) {
            this.$store.dispatch('logging/getActionLogs', Object.assign({}, this.filters, {
                page
            }));
        },

        cancel() {
            this.resetData();
            this.getLogs();
        },

        resetData() {
            this.filters = {
                types: [],
                startDate: null,
                endDate: null,
                userId: null
            };
        }
    }
};
</script>
